export default {
  unidadesNegocio: [
    'AGENCIAMENTO',
    'AMOSTRAS - COMERCIAL SERVIÇOS',
    'CONTA E ORDEM',
    'CORPORATIVO',
    'COSMETICO',
    'ENCOMENDA ESPECIAL',
    'ENCOMENDA PADRAO',
    'ENERGIA',
    'EXPORTAÇÃO',
    'EXPORTAÇÃO (SERVIÇO)',
    'ILUMINACAO',
    'INFORMÁTICA',
    'METANOL',
    'MINOR METALS',
    'OUTROS DISTRIBUIÇÃO',
    'PET - RESINA',
    'PNEUS',
    'PROPRIO DIVERSOS',
    'PVC - RESINA',
    'REPRESENTAÇÃO INTERNACIONAL',
    'SOLVENTES',
    'SUPLEMENTOS',
    'TEXTIL',
  ],
  unidadesNegocioComObj: [
    { nome: 'AGENCIAMENTO', id: 1 },
    { nome: 'AMOSTRAS - COMERCIAL SERVIÇOS', id: 2 },
    { nome: 'CONTA E ORDEM', id: 3 },
    { nome: 'CORPORATIVO', id: 4 },
    { nome: 'COSMETICO', id: 5 },
    { nome: 'ENCOMENDA ESPECIAL', id: 6 },
    { nome: 'ENCOMENDA PADRAO', id: 7 },
    { nome: 'ENERGIA', id: 8 },
    { nome: 'EXPORTAÇÃO', id: 9 },
    { nome: 'EXPORTAÇÃO (SERVIÇO)', id: 10 },
    { nome: 'ILUMINACAO', id: 11 },
    { nome: 'INFORMÁTICA', id: 12 },
    { nome: 'METANOL', id: 13 },
    { nome: 'MINOR METALS', id: 14 },
    { nome: 'OUTROS DISTRIBUIÇÃO', id: 15 },
    { nome: 'PET - RESINA', id: 16 },
    { nome: 'PNEUS', id: 17 },
    { nome: 'PROPRIO DIVERSOS', id: 18 },
    { nome: 'PVC - RESINA', id: 19 },
    { nome: 'REPRESENTAÇÃO INTERNACIONAL', id: 20 },
    { nome: 'SOLVENTES', id: 21 },
    { nome: 'SUPLEMENTOS', id: 22 },
    { nome: 'TEXTIL', id: 23 },
  ],
  unidadesNegocioSelecionada: [],
};
